module.exports = __webpack_public_path__ + "img/shu_6.a8c8afa2.png";